$(document).ready(function() {

  if (!GeoRedirect.isBot()) {
    var infScroll,
        maxInfiniteArticles = 2;

    var elem = document.getElementById('blog');

    if (!elem || !elem.querySelector('.article-container')) {
      return; 
    }

    function getNextArticleUrl() {
      var lastArticle = Array.prototype.slice.call(elem.querySelectorAll('.article-container'), -1)[0];
      if (typeof lastArticle === 'undefined' || !lastArticle) {
        return; 
      }
      var nextArticle = lastArticle.querySelector('.next-article');
      if (typeof nextArticle === 'undefined' || !nextArticle) {
        return; 
      }
      return nextArticle.href;
    }

    function showArticleUpcomingPost(element) {
      var id = element.getAttribute('id') + '-upcomingpost';
      var upcomingpost = element.querySelector('#' + id);
      if (!upcomingpost) {
        return;
      }
      upcomingpost.style.display = null; 
    }

    function removeArticleBreadcrumbs(element) {
      var breadcrumb = element.querySelector('#breadcrumb');
      if (!breadcrumb) {
        return;
      }
      if (typeof breadcrumb.remove === 'function') {
        breadcrumb.remove();
      } else {
        breadcrumb.parentNode.removeChild(breadcrumb); // IE
      }
    }

    function hideArticleNav(element) {
      if (!infScroll.options.hideNav) {
        return;
      }
      var nav = element.querySelector(infScroll.options.hideNav);
      if (!nav) {
        return;
      }
      nav.style.display = 'none';
    }

    function initShareButtons(element) {
      var shariff = element.querySelector('.shariff');
      if (!shariff) {
        return; 
      }
      new Shariff(shariff);
    }




    function initArticle(element) {
      showArticleUpcomingPost(element);
      removeArticleBreadcrumbs(element);
      hideArticleNav(element);
      initShareButtons(element);
    }

    function setupInfiniteScroll() {
      infScroll = new InfiniteScroll(elem, {
        path: function () {
          if (this.loadCount >= maxInfiniteArticles) {
            return; 
          }
          return getNextArticleUrl();
        },
        checkLastPage: true,
        append: '#blog .article-container',
        hideNav: '.prev-next-article',
        responseType: 'document',
        history: 'replace',
        historyTitle: true,
        scrollThreshold: 400
      }).on('append', function (response, path, items) {
        Array.prototype.slice.call(items).forEach(initArticle);

        if (typeof window.lazyLoadInstance !== 'undefined') {
          lazyLoadInstance.update();
        }

        if (!this.getPath()) {
          this.disableScrollWatch();
          return;
        }
      });
    }

    setupInfiniteScroll();
  }




  function initContentTable(element,selector) {

    if(!$('.article-container').hasClass(element)){
      return;
    }

    var tableHeadline = $('#headline1').prev("h1,h2,h3").text();
    $(selector).prev("h1,h2,h3").remove();
    $(selector).wrap('<div class="table-of-content-wrapper"></div>');
    $(selector).addClass('content-list');
    $('.table-of-content-wrapper').html('<div class="table-of-content"><p>'+tableHeadline+'</p></div>'+$('.table-of-content-wrapper').html());

    $(selector+' a').each(function(){
      if($(this).text() == ''){
        $(this).remove();
      }
    })

    $('.table-of-content').click(function(){
      $('.content-list').slideToggle('display');
      $('.table-of-content').toggleClass('active');
    });
  }

  initContentTable('article-fitness--hula-hoop-fitness','#headline1');




});